import React, {useState} from 'react';
import {Form, Button, Alert, Spinner} from 'react-bootstrap';
import {Formik} from 'formik';
//import {useHistory} from 'react-router-dom';

import axios from 'axios';
import {apiUrl} from '../../util/Api';
//import {setAuthentication, clearAuthentication} from '../util/Auth';

//import {useDispatch} from 'react-redux';
//import {saveUserStore, clearUserStore} from '../redux/slices/UserSlice';

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  password: Yup.string().min(8,'passwords need to be at least 8 characters').required('please enter a password')
});

const PasswordForm = () => {
  const [errors, setErrors] = useState([]);
  //const [visible, setVisible] = useState(true);
  const [successMsg, setSuccessMsg] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  //let history = useHistory();
  //const dispatch = useDispatch();

  const submitSubmit = (values, actions) => {
    //console.log("submitting form", values);
    setSubmitting(true)
    setErrors([]);
    setSuccessMsg(null);

    axios.post(apiUrl + '/users/updatepasswd', values, {withCredentials: true})
    .then((res) => {
      if(res.data.status === "ok") {
        //update info at all?
        //set cookie
        //setAuthentication(res.data.user, persist);
        //dispatch?
        //dispatch(saveUserStore(res.data.user));
        //hide form
        //setVisible(false);
        setSuccessMsg('Your password was successfully updated.')

      }
      else {
        //console.log('an error was returned');
        //display errors
        //clearAuthentication();
        //dispatch(clearUserStore());
        let errorMsgs = [];
        //reset TOS link?
        //values.tosAgree = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'password-missing':
              errorMsgs.push('Please enter a password.');
              break;
            case 'password-format':
              errorMsgs.push('Password must be 8 characters with at least one uppercase and one lowercase letter.');
              break;
            default:
              errorMsgs.push('There was an error updating your password.');
          }
        });
        setErrors(errorMsgs);
      }
      setSubmitting(false)
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      //clearAuthentication();
      //dispatch(clearUserStore());
      setErrors(['An error occurred while updating the password.']);
      setSubmitting(false)
    });
  }

  //check if logged in
  return (
    <div className='mt-3'>
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        successMsg !== null ? (
          <Alert variant='info'>
          {successMsg}
          </Alert>
        ) : (null)
      }
    <Formik validationSchema={validationSchema}
      onSubmit={submitSubmit}
      initialValues={{password:''}}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
          <Form.Group controlId='signup-password' className='mb-3'>
            <Form.Label>New Password</Form.Label>
            <Form.Control type="password" placeholder="password"
              name="password" value={values.password} onChange={handleChange}
              isInvalid={touched.password && errors.password}
            />
            <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
          </Form.Group>
          {submitting ? (
            <Button variant="info" disabled size='sm'><Spinner as="span" animation="border" size="sm"/> Updating...</Button>
          ) : (
            <Button variant="primary" type="submit" size='sm'>Update Password</Button>
          )}
        </Form>
      )}
    </Formik>
    </div>
  );
}


export default PasswordForm;
